import { authorizationStore } from '../../../../modules/authorization/authorization.store';
import { InputType } from '../../../../modules/authorization/authorization.type';
import { AuthInput } from '../../../../ui/authInput';
import { AuthSelect } from '../../../../ui/authSelect';
import { DateInput } from '../../../../ui/dateInput';
import { observer } from 'mobx-react-lite';

export const InputsPiece: React.FC<{
  inputs: Array<InputType> | undefined;
  typeofSection: string;
}> = observer(({ inputs, typeofSection }) => {
  const { setLoginForm } = authorizationStore;

  const checkValue = (
    name: string,
    value: string,
    isValid: boolean,
    errorMessage = '',
  ) => {
    setLoginForm(name, value, isValid, errorMessage);
  };

  if (inputs) {
    return (
      <div className="logInMainHolder">
        {inputs?.map((input: InputType) => {
          if (input.typeOfInput === 'select') {
            return (
              <AuthSelect key={input.id} input={input} initValue={input.value} onChange={checkValue} />
            );
          }
          if (input.typeOfInput === 'date') {
            return (
              <DateInput key={input.id} input={input} onChange={checkValue} />
            );
          }
          return (
            <AuthInput
              key={input.id}
              input={input}
              value={input.value}
              onChange={checkValue}
              typeofSection={typeofSection}
            />
          );
        })}
      </div>
    );
  }
  return null;
});
